import { useRef } from 'react';

const INTERACTIVE =
  'button, a, input, textarea, select, [role="slider"], [contenteditable="true"], [data-no-tab-swipe]';
export default function useTabSwipe({ values, value, onChange, enabled = true }) {
  const gesture = useRef(null);
  return {
    onTouchStart(event) {
      gesture.current = null;
      if (
        !enabled ||
        window.innerWidth >= 768 ||
        event.touches.length !== 1 ||
        event.target.closest(INTERACTIVE)
      )
        return;
      const point = event.touches[0];
      if (point.clientX < 20 || point.clientX > window.innerWidth - 20) return;
      gesture.current = { x: point.clientX, y: point.clientY };
    },
    onTouchMove(event) {
      if (event.touches.length !== 1) gesture.current = null;
      const start = gesture.current;
      const point = event.touches[0];
      // Once vertical scrolling starts, never turn it into a tab switch.
      if (
        start &&
        point &&
        Math.abs(point.clientY - start.y) > 24 &&
        Math.abs(point.clientY - start.y) > Math.abs(point.clientX - start.x)
      )
        gesture.current = null;
    },
    onTouchEnd(event) {
      const start = gesture.current;
      gesture.current = null;
      const end = event.changedTouches[0];
      if (!start || !end || event.touches.length) return;
      const dx = end.clientX - start.x;
      const dy = end.clientY - start.y;
      if (
        Math.abs(dx) < Math.max(48, event.currentTarget.clientWidth * 0.12) ||
        Math.abs(dx) < Math.abs(dy) * 2
      )
        return;
      const next = values[values.indexOf(value) + (dx < 0 ? 1 : -1)];
      if (next !== undefined && next !== value) onChange(next);
    },
    onTouchCancel() {
      gesture.current = null;
    },
  };
}
